
export const EVENTS = {
  SCENE_ASSETS_LOAD_UPDATE: 'SCENE_ASSETS_LOAD_UPDATE',
  SCENE_ASSETS_LOADED: 'SCENE_ASSETS_LOADED',
  SCENE_READY: 'SCENE_READY',

  MOVE_TO_HEAVEN_START: 'MOVE_TO_HEAVEN_START',
  MOVE_TO_HEAVEN_END: 'MOVE_TO_HEAVEN_END',
  MOVE_TO_TOWN_START: 'MOVE_TO_TOWN_START',
  MOVE_TO_TOWN_END: 'MOVE_TO_TOWN_END',

  SHOW_GOD: 'SHOW_GOD',
};

export default null;



// WEBPACK FOOTER //
// ./src/js/shared/Events.js